import { render, staticRenderFns } from "./CelerisPayment.vue?vue&type=template&id=5a4e9b54&scoped=true"
import script from "./CelerisPayment.vue?vue&type=script&lang=js"
export * from "./CelerisPayment.vue?vue&type=script&lang=js"
import style0 from "./CelerisPayment.vue?vue&type=style&index=0&id=5a4e9b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e9b54",
  null
  
)

export default component.exports